import { SET_PLAYER_ERROR, SET_API_ERROR, CLEAR_API_ERROR } from '../../constants'

export default function PlayerErrorReducer(
  state = {}, { type, error, apiError } = {}
) {
  switch (type) {
    case SET_PLAYER_ERROR: {
      return {
        ...state,
        error,
      }
    }
    case SET_API_ERROR: {
      return {
        ...state,
        apiError,
      }
    }
    case CLEAR_API_ERROR: {
      const newState = { ...state, apiError: { ...state.apiError, apiError: null } }
      return newState
    }
    default:
      return {
        ...state,
        error: false,
      }
  }
}
